import React, { Component } from "react";
import {
  Card,
  PieChart,
  TabsCustom,
  TabsCustomBody,
  TabsCustomHeader,
  TabsCustomItem,
  TabsCustomMenu,
} from "ui-kit-ck-consultant";

import PerimeterBadge from "./PerimeterBadge";

import { getCurrencyValue, getPercentageValue } from "../../utils/general";

const formatCurrency = (value) => {
  const n = Number(value);
  return getCurrencyValue(Number.isFinite(n) ? n : 0);
};

export class Mission extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabsId: 0,
      tabs: ["Volume", "CA"],
    };
  }

  render() {
    const folderCompany = (this.props.data && this.props.data.folderCompany) || [];
    const CACompany = (this.props.data && this.props.data.CACompany) || [];
    const legacyMission = (this.props.data && this.props.data.mission) || [];

    // Fallback for legacy payload shape (mission only) — keeps the widget
    // working if the dashboard is hit before the backend redeploys.
    const volumeData = folderCompany.length
      ? folderCompany.map((c) => ({
          labels: c.name
            ? `${c.name} (${getPercentageValue(c.percentage)})`
            : `Autre (${getPercentageValue(c.percentage)})`,
          data: c.total,
          color: c.color,
        }))
      : legacyMission;

    const caData = CACompany.map((c) => ({
      labels: c.name
        ? `${c.name} (${getPercentageValue(c.percentage)})`
        : `Autre (${getPercentageValue(c.percentage)})`,
      data: c.data,
      color: c.color,
    }));

    const totalVolume = (folderCompany.length ? folderCompany : []).reduce(
      (acc, c) => acc + (c.total || 0),
      0,
    ) || legacyMission.reduce((acc, c) => acc + (c.data || 0), 0);
    const totalCA = CACompany.reduce((acc, c) => acc + (c.data || 0), 0);
    const isCA = this.state.tabsId === 1;

    return (
      <Card
        className="mb-10"
        title="Répartition compagnie"
        action={
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "12px",
              color: "#6b7280",
              fontWeight: 500,
            }}
          >
            <span>
              {isCA
                ? `${formatCurrency(totalCA)} · 6 derniers mois`
                : `${totalVolume.toLocaleString("fr-FR")} missions · 6 derniers mois`}
            </span>
            {this.props.perimeter && (
              <PerimeterBadge perimeter={this.props.perimeter} compact />
            )}
          </span>
        }
      >
        <TabsCustom>
          <TabsCustomHeader noCard>
            {this.state.tabs.map((label, key) => (
              <TabsCustomMenu
                noCard
                key={key}
                title={label}
                active={this.state.tabsId === key}
                onClick={() => this.setState({ tabsId: key })}
              />
            ))}
          </TabsCustomHeader>
          <TabsCustomBody noCard>
            <TabsCustomItem active={this.state.tabsId === 0}>
              <PieChart
                digits={0}
                legendDisplay={true}
                positionLegend="right"
                height={320}
                data={volumeData}
              />
            </TabsCustomItem>
            <TabsCustomItem active={this.state.tabsId === 1}>
              <PieChart
                legendDisplay={true}
                positionLegend="right"
                format="currency"
                height={320}
                data={caData}
              />
            </TabsCustomItem>
          </TabsCustomBody>
        </TabsCustom>
      </Card>
    );
  }
}

export default Mission;
